import { ExternalLink } from 'lucide-react';
import type { LinkWidgetData } from '@/types';

interface LinkWidgetProps {
  data: LinkWidgetData;
  preview?: boolean;
}

const LinkWidget = ({ data, preview = false }: LinkWidgetProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (preview) {
      e.preventDefault();
    }
  };

  return (
    <a
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="flex items-center gap-4 p-4 bg-white dark:bg-dark-800 rounded-2xl shadow-soft dark:shadow-none hover:shadow-card transition-all duration-200 group"
    >
      {data.icon ? (
        <div className="w-12 h-12 bg-gray-100 dark:bg-dark-700 rounded-xl flex items-center justify-center overflow-hidden">
          <img
            src={data.icon}
            alt=""
            className="w-8 h-8 object-contain"
          />
        </div>
      ) : (
        <div className="w-12 h-12 bg-lime-100 rounded-xl flex items-center justify-center">
          <ExternalLink className="w-5 h-5 text-lime-600" />
        </div>
      )}
      <span className="flex-1 font-medium text-dark-800 dark:text-white truncate">
        {data.title}
      </span>
      <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-lime-500 transition-colors" />
    </a>
  );
};

export default LinkWidget;
